export default {
  noExperimentsQuantumEvaluator: 'There are currently no experiments evaluated.',
  noExperimentsOtherUsers: 'The Data Science Team is working hard on evaluating your experiments. Please check back soon to see your results.',
};
